import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Outlet, useMatch } from 'react-router-dom';
import { paths } from '@/app/paths';
import { AuthenticatedPageLayout } from '@/components/layouts/AuthenticatedPageLayout';
import { AdminModeProvider } from '@/context/adminModeContext';
import { setAdminModeToggle } from '@/features/userPrefs/userPrefsSlice';

/**
 * Element for the root route. Renders the page layout once for every page under it, so
 * navigating between pages doesn't remount the nav, drawers and auth hooks.
 */
export const AppLayout = () => {
	const dispatch = useDispatch();
	const isAdminRoute = Boolean(useMatch(`${paths.admin}/*`));

	// Admin mode follows the route: opening or going to a CRM page turns the toggle off.
	// This only runs when moving between admin and CRM pages, so switching the toggle on
	// from a CRM page isn't undone before the navigation to /admin finishes.
	useEffect(() => {
		if (!isAdminRoute) {
			dispatch(setAdminModeToggle(false));
		}
	}, [dispatch, isAdminRoute]);

	return (
		<AdminModeProvider isAdminMode={isAdminRoute}>
			<AuthenticatedPageLayout>
				<Outlet />
			</AuthenticatedPageLayout>
		</AdminModeProvider>
	);
};
